import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HASH_MAP = {
  '#/': '/',
  '#/services/express': '/expressbookings',
  '#/services/temple': '/servicesattemple',
  '#/services/outside-temple': '/outsidetemple',
  '#/services/donation': '/donation',
  '#/services/rentals': '/hallbooking',
  '#/events': '/events',
  '#/events/religious': '/events/religious',
  '#/events/cultural': '/events/cultural',
  '#/activities/cultural': '/activities',
  '#/events/education': '/events/education',
  '#/activities/education': '/activities',
  '#/events/youth': '/events',
  '#/events/other': '/events',
  '#/gallery/photos': '/gallery/photos',
  '#/gallery/videos': '/gallery/videos',
  '#/visit-info/location-directions': '/location',
  '#/visit-info/hotels': '/hotels',
  '#/visit-info/faq': '/faq',
  '#/visit-info/temple-prasadam-policy': '/prasadamPolicy',
  '#/about-us/temple-history': '/templehistory',
  '#/about-us/article-bylaws': '/articlesandbylaws',
  '#/about-us/management': '/management',
  '#/about-us/contact-us': '/contactus',
  '#/profile': '/profile',
  '#/change_password': '/changepassword',
  '#/donation_report': '/report',
  '#/sitemap.xml': '/sitemap.xml'
};

export default function HashRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash; // reads "#/services/express"
    if (!hash || hash === '#/') return;
    if (hash === '#/sitemap.xml') {
      window.location.href = '/sitemap.xml';
      return;
    }
    const newPath = HASH_MAP[hash];
    if (newPath) {
      navigate(newPath, { replace: true });
    } else {
      // 👇 NEW: redirect unknown hash to fallback page
      navigate('/legacy-redirect', { replace: true });
    }
  }, [navigate]);

  return null; // renders nothing, just runs the logic
}
